import React, {Component} from "react";
import {Link} from "react-router-dom";

export default class MainNavigationLinks extends Component {
    constructor(props) {
        super(props);
        this.links = {
            Home: '/',
            Projekte: '/projects'
        };
    }

    renderLinks = () => {
        let links = [];
        for (let link in this.links) {
            let className = this.isLocationActive(this.links[link]) ? 'nav-link active' : 'nav-link';
            links.push(<Link key={link} to={this.links[link]} className={className}>{link}</Link>);
        }
        return links;
    };

    isLocationActive = (location) => {
        return window.location.pathname === location;
    };

    render() {
        return (
            <ul className="navbar-nav">
                {this.renderLinks()}
            </ul>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/MainNavigationLinks.js